'use client'
import { Tag, TagSizes, Text, Tooltip } from '../../atoms'
import { TextTypes } from '../../../types'
import React from 'react'

export interface ListHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
    title?: string
    headerSize?: TextTypes.HEADING_1 | TextTypes.HEADING_2 | TextTypes.HEADING_3
    count?: number
    tooltip?: string
    actions?: React.ReactElement | React.ReactElement[]
    contentSwitcher?: React.ReactElement
    selectInput?: React.ReactElement
    bottomContent?: React.ReactElement
}

export const ListHeader = ({
    title,
    headerSize = TextTypes.HEADING_2,
    count,
    tooltip,
    actions,
    contentSwitcher,
    selectInput,
    bottomContent,
    ...props
}: ListHeaderProps): JSX.Element => {
    return (
        <div {...props} className={`grid gap-2 pb-3 border-b border-border-default ${props.className ?? ''}`}>
            <div className="flex items-center gap-2">
                <Text type={headerSize}>{title}</Text>
                {count && count > 0 && (
                    <Tag size={TagSizes.SMALL} className="shrink-0">
                        {count}
                    </Tag>
                )}
                {tooltip && (
                    <span className="shrink-0">
                        <Tooltip content={tooltip} />
                    </span>
                )}
                {actions && <span className="inline-flex gap-0.5 ml-auto shrink-0">{actions}</span>}
            </div>
            {contentSwitcher && <div className="w-full flex">{contentSwitcher}</div>}
            {selectInput && selectInput}
            {bottomContent && bottomContent}
        </div>
    )
}
